import React from "react";
import { useRecoilState } from "recoil";
import { Icon, Menu } from "semantic-ui-react";

import { viewingDescription } from "./atoms";

import { commands$ } from "./CommandsStream";
import { useIsMobile } from "./utils";

export function DescriptionButton({showLabel = false}) {
  const isMobileDevice = useIsMobile();
  const [active, setActive] = useRecoilState(viewingDescription);

  const toggle = () => {
    setActive(!active);
    commands$.showDescription();
  };

  return (
    <Menu.Item onClick={toggle} active={active}>
      <Icon name="info" />
      <br />
      {(isMobileDevice || showLabel) ? "Description" : null}
    </Menu.Item>
  );
}
